import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import { useLocale } from '@/hooks/use-locale'
import Header from '@/components/generals/header'
import Footer from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({
    children,
    tone = 'light',
    headerTone,
    hideFooter = false
}): ReactNode => {
    const { locale } = useLocale()

    return (
        <div className={cn('flex min-h-screen flex-col', tone === 'dark' ? 'bg-night text-white' : 'paper-texture')}>
            <Header tone={headerTone ?? tone} />

            <main id='main' lang={locale} className='flex-1'>
                {children}
            </main>

            {!hideFooter && <Footer />}
        </div>
    )
}
